import docReady from "./misc/docReady";

var VIV = {
    behaviours: {},
    attachBehaviours: function (context) {
        Object.entries(VIV.behaviours).forEach(function ([behaviourName, behaviour]) {
            if (typeof behaviour.attach === "function") {
                behaviour.attach(context);
            }
        });
    }
};

// Make VIV a global;
window.VIV = VIV;

// Fade in page when was hidden
VIV.behaviours.assets = {
    attach: function () {
        if (document.body.style.opacity === '0') {
            document.body.style.opacity = '1';
        }
    }
};

// Attach behaviours when all dom elements are loaded
docReady(function () {
    const rootContext = document.documentElement;
    VIV.attachBehaviours(rootContext);
});

if (typeof wp !== 'undefined' && typeof wp.data !== 'undefined') {
    wp.data.subscribe(function () {
        const blocks = document.documentElement.querySelectorAll('.acf-block-preview');
        blocks.forEach(function (block) {
            if (!block.classList.contains('viv-loaded')) {
                VIV.attachBehaviours(block);
                block.classList.add('viv-loaded');
            }
        });
    });
}

// Disable double click
document.ondblclick = function(e) {
    e.preventDefault();
}

